import { render, staticRenderFns } from "./pcgoods.vue?vue&type=template&id=75ed54d5"
import script from "./pcgoods.vue?vue&type=script&lang=js"
export * from "./pcgoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports